import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

const vuetifyOpts = {
    rtl: false,
    theme: {
        dark: false,
        themes: {
            dark: {
                primary: "#4cbec5",
                accent: "#f179a1",
                secondary: "#82ceab",
                success: "#93cf96",
                info: "#7ac0f8",
                warning: "#fcae4c",
                error: "#ff8585",
                background: colors.teal.base, // Not automatically applied
            },
            light: {
                primary: "#00a3ad",
                accent: "#EC407A",
                secondary: "#4DBA87",
                success: "#66BB6A",
                info: "#42A5F5",
                warning: "#FB8C00",
                error: "#FF5252",
                background: colors.teal.lighten5, // If not using lighten/darken, use base to return hex
            }
        }
    }
}
  
export default new Vuetify(vuetifyOpts);
